module.exports = __webpack_public_path__ + "img/stats_default.399f538d.png";